import PersistStorage from './persist-storage'

class ExpiringStorage {
  get(key) {
    const cached = JSON.parse(
        PersistStorage.getItem(key)
    )

    if (! cached) {
      return null
    }

    const expires = new Date(cached.expires)

    if (expires < new Date()) {
      PersistStorage.removeItem(key)
      return null
    }

    return cached.value
  }

  set(key, value, lifeTimeInMinutes) {
    const currentTime = new Date().getTime()

    const expires = new Date(currentTime + lifeTimeInMinutes * 60000)

    PersistStorage.setItem(key, JSON.stringify({value, expires}))
  }
}

const expireStorage = new ExpiringStorage()
export default expireStorage
